const VideoChoiceEnum = Object.freeze({
  PLAIN: "plain",
  AUDIO_DESCRIPTION: "description",
  IRISH_SIGN_LANGUAGE: "isl",
});

export default VideoChoiceEnum;
